<template>
  <div class="wrap-bg wrap-data-manage wrap-content-detail pd15">
    <v-breadcrumb v-if="isShowBread" :breadcrumb-list="breadcrumbList" />
    <div
      v-loading="isLoad"
      element-loading-text="加载中"
      element-loading-spinner="el-icon-loading"
      class="bg-white main-con breadcrumb-btm-con-box">
      <!-- <h3 class="f-fwn bor-btm-gray pd-column10-row15 f-fs16">{{ baseInfoObj.title }}</h3> -->
      <!-- 内容编辑模块 -->
      <manage-edit
        ref="manageEdit"
        :form-arr="formArr"
        :page-type="paramObj.type"
        @formItemEdit="formItemEdit"
        @componentChange="componentChange"
        @saveBtn="saveBtn"
        @cancelBtn="cancelBtn" />
    </div>
  </div>
</template>

<script>
import vBreadcrumb from '@/components/breadcrumb.vue'
import manageEdit from '@/components/manageEdit.vue'
import $filterCommon from '@/components/form-filter/index.js'
import pageConfig from './page.config'
import mixin from '@/mixin/manageEdit'
import {
  getDetailInfo,
  addContent,
  updateContent
} from '@/api/dataManage/exponential.js'
export default {
  components: {
    vBreadcrumb,
    manageEdit
  },
  mixins: [mixin],
  data() {
    return {
      isShowBread: false,
      breadcrumbList: [
        {
          name: '数据管理'
        },
        {
          name: '指数数据管理',
          path: '/dataManage/list'
        },
        {
          name: '详情'
        }
      ],
      isLoad: false,
      paramObj: {}, // 详情参数
      baseInfoObj: {
        title: '新增内容数据'
      },
      formArr: [],
      chinaData: [],
      foreignData: []
    }
  },
  created() {
    // console.log(this.$store.state.userInfo)
    // 获取参数
    this.paramObj = this.$route.query
    // 页面表单修改内容初始化初始化
    this.formArr = this.formInt(pageConfig.detailInfos)
    // 页面初始化
    if (this.paramObj.type === 'add') {
      this.breadcrumbList[this.breadcrumbList.length - 1].name = '新增'
      this.init()
    } else {
      this.getDetailInfo(this.paramObj, data => {
        this.init(data)
      })
    }
  },
  methods: {
    init() {
      this.isLoad = true
      // 请求所有条件
      const filterAjaxList = JSON.parse(JSON.stringify(pageConfig.filterAjaxList))
      Promise.all(filterAjaxList.map(item => $filterCommon.getLabelCommon(item.method, item.url, item.param, item))).then(data => {
        this.isLoad = false
        // 拿到数据之后数据处理
        this.formArr = this.ajaxFinishInt(data, this.formArr)
        // 如果是新增或者编辑只有一个模块时，默认基础信息打开编辑
        if (this.paramObj.type === 'add' || this.formArr.length === 1) this.formItemEdit(this.formArr[0], 0)
      })
    },
    // 获取基本信息
    getDetailInfo(paramObj, cb) {
      this.isLoad = true
      getDetailInfo(paramObj).then(res => {
        this.isLoad = false
        const data = res.data || {}
        // 保存原始值
        this.baseInfoObj = {}
        for (const key in data) {
          this.baseInfoObj[key] = data[key] || ''
        }
        // this.breadcrumbList[this.breadcrumbList.length - 1].name = this.baseInfoObj.title
        // 赋值
        this.formArr.forEach(item => {
          if (item.infosList && item.infosList.length) {
            item.infosList.forEach(elem => {
              // 处理带有单位的回显
              let val = data[elem.key] || elem.initVal || ''
              if (elem.isParamAddUnit && elem.unit && val) val = val.replace(elem.unit, '')
              // 初始化值
              elem.value = val
              elem.inpVal = elem.value || ''
            })
          }
          return item
        })
        cb && cb(data)
      })
    },
    // 下拉修改
    componentChange($event, item, flag, pIndex) {
    },
    // 保存按钮
    saveBtn(item, index) {
      const getParamObj = this.saveParam(item, index)
      // 如果返回false或者没有被修改过，则直接终止
      if (!getParamObj || !getParamObj.isInsert) return
      // 整理保存参数
      const param = Object.assign({
        userId: this.$store.state.userInfo.userId, // 当前用户id
        userName: this.$store.state.userInfo.userName, // 当前用户name
        updateType: item.updateType
      }, getParamObj.param)
      // 开始请求保存接口
      console.log(JSON.stringify(param))
      this.saveModelInfo(param, item, index)
    },
    // 保存接口
    saveModelInfo(param, item, index) {
      if (this.baseInfoObj.platform && this.baseInfoObj.brand) {
        updateContent(param).then(res => {
          this.saveSuccessAfterHandle(item, index, param, res)
        })
      } else {
        addContent(param).then(res => {
          this.saveSuccessAfterHandle(item, index, param, res)
        })
      }
    },
    // 保存后处理
    saveSuccessAfterHandle(item, index, param, res) {
      item.isSaveLoading = true
      setTimeout(() => {
        item.isSaveLoading = false
        const data = res.data || {}
        if (data.message.indexOf('成功') >= 0) {
          // 添加后都是修改
          this.paramObj.type = 'edit'
          this.$bus.$emit('updateExponentialList')
          // 成功之后回调
          this.saveSuccessfn(item, index, param)
        } else {
          this.$message({
            type: 'error',
            message: data.message || '保存失败！'
          })
        }
      }, 1500)
    }
  }
}
</script>

<style lang="less" scoped>
@import '~@/assets/less/color.less';
/deep/.breadcrumb-btm-con-box{
  min-height: calc(~'100vh - 60px');
}
</style>
